import Header from './components/header/Header';
import Footer from './components/footer/Footer';

const Layout = ({ children }) => {
  return (
    <div className="site-wrapper">
      <Header />
      <main className="site-main">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;